import { createSelector } from 'reselect';
import { isFeatureEnabled } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';
import { PLCC_BANNER_COOKIE_FLAGNAME, PLCC_BANNER_HEADER_FLAGNAME } from '../common/Constants';

export const DEFAULTS = {};

const isPlccBannerEnabled = (featureFlags, preferences, reqHeaders) =>
    isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,        cookieName            headerName
        'enablePaymentsPLCCBanner',
        PLCC_BANNER_COOKIE_FLAGNAME,
        PLCC_BANNER_HEADER_FLAGNAME
    );

// FF
export const selectPlccBannerThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isPlccBannerEnabled
);
